import type { CSSProperties } from 'react'

/**
 * Column labels for a `.table--stack` table (styles/tables.css).
 *
 * Pass the labels of columns 2 onward, in order; column 1 is each card's heading and
 * takes none. Returns the custom properties the stacked layout prints in front of
 * each value, quoted the way `content:` needs them.
 */
export function stackLabels(labels: string[]): CSSProperties {
  const style: Record<string, string> = {}
  labels.forEach((label, index) => {
    style[`--l${index + 2}`] = JSON.stringify(label)
  })
  return style as CSSProperties
}
